import { DesignSchemeSet } from '@data/buildingProjects/DesignSchemeSet';
import FVector from '@data/geometry/FVector';
import { DesignSchemeRenderer } from '@rendering/DesignSchemes/DesignSchemeRenderer';
import { OrientedVolumeRenderer } from '@rendering/DesignSchemes/SingleVolume/OrientedVolumeRenderer';
import { OrientedVolumeDesignState, SchemeKey, type LayerKind } from '@visualizer/types';
import Layer from 'Simulations/Layer';
import { DesignScheme } from '../designScheme';

/**
 * DesignScheme subclass implementing an oriented extrusion volume.
 * Syncs its renderer with Zustand configuration for dynamic control.
 */
export class OrientedVolume extends DesignScheme {
    constructor(
        footprint: FVector[],
        footprintId: string,
        set: DesignSchemeSet,
        config: OrientedVolumeDesignState,
        linkedLayers?: Map<LayerKind, Layer>
    ) {
        super(footprint, footprintId, set, config, linkedLayers);

        // Initialize visibility and update state:
        if (config.active) this.update();
    }

    // Renderer Factory & Defaults:
    protected override createRenderer(config: OrientedVolumeDesignState): DesignSchemeRenderer {
        return new OrientedVolumeRenderer(this, config);
    }

    override getRendererKey() {
        return SchemeKey.ORIENTED_VOLUME;
    }
}
